import { withRestoreParam } from "@impero-com/ui/domain";
import { Navigate, useLocation } from "react-router-dom";

import { WebRoute } from "../routes";
import { useDashboardRights } from "../utils/hooks/useDashboardRights";

export function HomeRedirect() {
    const hasDashboardRights = useDashboardRights();
    const { search, hash } = useLocation();
    if (hasDashboardRights) {
        return <Navigate to={WebRoute.DASHBOARD_V2 + search + hash} replace />;
    }

    const destination = withRestoreParam(
        WebRoute.DASHBOARD_PENDING_ACTIVITIES + search
    );

    return <Navigate to={destination + hash} replace />;
}
